import { AutogenModelBillingHistory, AutogenRowBillingHistory } from "./autogen/AutogenModelBillingHistory";

export class ModelBillingHistory extends AutogenModelBillingHistory<RowBillingHistory> {
	constructor() {
		super(RowBillingHistory);
	}
}

export class RowBillingHistory extends AutogenRowBillingHistory {
}